import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import getBuildDate from 'utils/getBuildDate';

function isLocalhost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.hostname === 'localhost';
}

const REPORTABLE_AXIOS_STATUS_CODES = new Set([403, 404]);

function isReportableAxiosErrorFn(originalException: unknown): boolean | null {
  const error = originalException as AxiosError | undefined;

  if (error?.isAxiosError) {
    const statusCode = error.response?.status;
    if (typeof statusCode === 'number') {
      return REPORTABLE_AXIOS_STATUS_CODES.has(statusCode);
    }
    return false;
  }

  return null;
}

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn || isLocalhost()) {
    return;
  }

  const environment = import.meta.env.MODE || 'production';

  Sentry.init({
    dsn,
    environment,
    release: getBuildDate(window.document),
    beforeSend: (event, hint) => {
      const isReportableAxiosError = isReportableAxiosErrorFn(
        hint?.originalException,
      );
      const shouldSendEvent = isReportableAxiosError ?? true;
      return shouldSendEvent ? event : null;
    },
  });
}
